import { gql } from '@efficiently/client-core-graphql-models';

export const GET_PLAN_TO_SCHEDULE_STATUS = gql(`
	query getStatusPlanToSchedules($projectId: String!) {
		getStatusPlanToSchedules(projectId: $projectId)
	}
`);
